import Icon from "@ant-design/icons";

export default function CarbonFootprintIcon(props: any) {
  return (
    <Icon
      component={() => (
        <svg
          width="1em"
          height="1em"
          viewBox="0 0 16 12"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M4.33366 11.3334C3.31144 11.3334 2.44477 10.9779 1.73366 10.2667C1.02255 9.55564 0.666992 8.68897 0.666992 7.66675C0.666992 6.80008 0.936437 6.03619 1.47533 5.37508C2.01421 4.71397 2.68921 4.28897 3.50033 4.10008C3.7781 3.10008 4.3281 2.27786 5.15033 1.63341C5.97255 0.98897 6.92255 0.666748 8.00033 0.666748C9.32255 0.666748 10.4309 1.12508 11.3253 2.04175C12.2198 2.95841 12.667 4.05564 12.667 5.33341C13.5003 5.4223 14.1531 5.76675 14.6253 6.36675C15.0975 6.96675 15.3337 7.61675 15.3337 8.31675C15.3337 9.15008 15.042 9.86119 14.4587 10.4501C13.8753 11.039 13.167 11.3334 12.3337 11.3334H4.33366ZM4.33366 10.0001H12.3337C12.8003 10.0001 13.1948 9.83897 13.517 9.51675C13.8392 9.19453 14.0003 8.80008 14.0003 8.33341C14.0003 7.86675 13.8392 7.4723 13.517 7.15008C13.1948 6.82786 12.8003 6.66675 12.3337 6.66675H11.3337V5.33341C11.3337 4.41119 11.0087 3.62508 10.3587 2.97508C9.70866 2.32508 8.92255 2.00008 8.00033 2.00008C7.30032 2.00008 6.6781 2.19175 6.13366 2.57508C5.58921 2.95841 5.18921 3.45008 4.93366 4.05008C5.80033 4.19453 6.5281 4.60286 7.11699 5.27508C7.70588 5.9473 8.00033 6.74453 8.00033 7.66675H6.66699C6.66699 7.0223 6.43921 6.4723 5.98366 6.01675C5.5281 5.56119 4.9781 5.33341 4.33366 5.33341C3.68921 5.33341 3.13921 5.56119 2.68366 6.01675C2.2281 6.4723 2.00033 7.0223 2.00033 7.66675C2.00033 8.31119 2.2281 8.86119 2.68366 9.31675C3.13921 9.7723 3.68921 10.0001 4.33366 10.0001Z"
            fill="currentColor"
          />
        </svg>
      )}
      {...props}
    />
  );
}
